/**
 * Randrush branding.
 *
 * Before, this module chose between AYG and RYG brands based on hostname.
 * Randrush is a single brand: no hostname branching, no second logo. The
 * functions return the same asset and keep the signature so consumers are
 * untouched.
 */

import rrcIcon from "../assets/images/brand/rrc-icon.svg";
import rrcLogo from "../assets/logo.png";

export const BRAND_TITLE = "Randrush";

/** Horizontal brand logo (transparent background, works on both themes). */
export const getLogoByHostname = () => rrcLogo;

/** Brand title. */
export const getBrandTitleByHostname = () => BRAND_TITLE;

/** Hook returning the current logo (same image in both themes). */
export const useLogo = () => rrcLogo;

/** Hook returning the brand title. */
export const useBrandTitle = () => BRAND_TITLE;

/** Square monogram (app icon). */
export const getMonogramByHostname = () => rrcIcon;

/** Hook returning the current monogram. */
export const useMonogram = () => rrcIcon;

export const getCompanyName = () => "Grupo Venelotto C.A.";
